import React from 'react';

export interface TabItem<T extends string> {
  value: T;
  label: React.ReactNode;
}

interface TabsProps<T extends string> {
  tabs: TabItem<T>[];
  active: T;
  onChange: (value: T) => void;
  className?: string;
}

const Tabs = <T extends string>({ tabs, active, onChange, className }: TabsProps<T>) => (
  <div className={`tabs${className ? ` ${className}` : ''}`}>
    {tabs.map(tab => (
      <button
        key={tab.value}
        type="button"
        className={`tabs-tab${active === tab.value ? ' tabs-tab-active' : ''}`}
        onClick={() => onChange(tab.value)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export { Tabs };
